module.exports = __webpack_public_path__ + "img/paytm.bd69fce2.jpg";